import winnerArchiveDetail from './Main'

const route = {
  path: '/archive/winner/:year/:categoryName/:name',
  name: 'winnerArchiveDetail',
  meta: {
    title: 'Archive - A D M A N 2 0 1 9'
  },
  component: winnerArchiveDetail
}

export default route
